// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__VRmup","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__29086"};